export const categoriesWithTickersHoldingsWhenIsConnected = [6, 10, 11,13];
export const classesToShowAccountsAllocation = [2,3,9];